import type { ConfigurationContextValue } from "./ConfigurationContext";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
import darkModeLogo from "./logos/nodale_glyph_dark.png";
import lightModeLogo from "./logos/nodale_glyph_light.png";

export const defaultDarkModeLogo = darkModeLogo;
export const defaultLightModeLogo = lightModeLogo;

export const defaultCurrency = "EUR";

export const defaultTitle = "Nodale";

export const defaultCompanySectors = [
  { value: "construction", label: "Bau & Handwerk" },
  { value: "services", label: "Dienstleistung" },
  { value: "energy", label: "Energie" },
  { value: "finance-insurance", label: "Finanzen & Versicherung" },
  { value: "health-care", label: "Gesundheit" },
  { value: "retail", label: "Handel" },
  { value: "real-estate", label: "Immobilien" },
  { value: "industrials", label: "Industrie" },
  { value: "information-technology", label: "IT & Software" },
  { value: "other", label: "Sonstiges" },
];

export const defaultDealStages = [
  { value: "new-lead", label: "Neuer Lead" },
  { value: "contacted", label: "Kontaktiert" },
  { value: "qualified", label: "Qualifiziert" },
  { value: "meeting", label: "Termin" },
  { value: "proposal-sent", label: "Angebot" },
  { value: "won", label: "Gewonnen" },
  { value: "lost", label: "Verloren" },
];

export const defaultDealPipelineStatuses = ["won"];

export const defaultDealCategories = [
  { value: "new-business", label: "Neukunde" },
  { value: "existing-customer", label: "Bestandskunde" },
  { value: "referral", label: "Empfehlung" },
  { value: "other", label: "Sonstiges" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Kalt", color: "#7dbde8" },
  { value: "warm", label: "Warm", color: "#e8cb7d" },
  { value: "hot", label: "Heiß", color: "#e88b7d" },
  { value: "in-contract", label: "Abgeschlossen", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "none", label: "Keine" },
  { value: "call", label: "Anruf" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "email", label: "E-Mail" },
  { value: "meeting", label: "Termin" },
  { value: "follow-up", label: "Follow-up" },
  { value: "proposal", label: "Angebot" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
